import React from 'react';
import Flexbox from 'flexbox-react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import ProcessUtils from 'utils/ProcessUtils';
import Constants from 'utils/Constants';
import ProcessField from 'components/core/fields/ProcessField';
import RIEComboBox from 'components/core/editable/RIEComboBox';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import { colorTextGrey } from 'styles/base';
const emptyStyles = css`
                color: ${colorTextGrey};
                font-style: italic;
                padding: 5px 0;
            `;


export default class VariableDimensionsField extends ProcessField {
    static propTypes = Object.assign({
        retrievedVariableName: PropTypes.string,
        labelWidth: PropTypes.string
    }, ProcessField.propTypes);

    constructor(props) {
        super(props);
        this._initializePropDependentVariables(props);
    }

    componentWillUpdate(nextProps, nextState) {
        this._initializePropDependentVariables(nextProps);
    }

    _initializePropDependentVariables(props) {
        this.retrievedVariable = props.process.variable_retrieval.retrieved_variables[props.retrievedVariableName];
    }

    getDimensionOptions = () => {
        let options = [];
        const coordinateSystemName = this.retrievedVariable.coordinate_system;
        if (coordinateSystemName) {
            options = ProcessUtils.getDimensionNamesAsArray(this.props.process, coordinateSystemName);
        }
        options = options.filter((dimensionName) => {
            return this.retrievedVariable.dims.indexOf(dimensionName) === -1;
        });

        return Constants.convertArrayToSelectOptions(options);
    };

    onDimensionNameUpdated = (fieldPath, value, onChangeData) => {
        const oldDimensionName = onChangeData.oldName;
        const newDimensionName = value.value;
        const coordinateSystemName = this.retrievedVariable.coordinate_system;
        const coordinateSystemDimensions = ProcessUtils.getDimensionNamesAsArray(this.props.process, coordinateSystemName);

        const editor = ProcessUtils.getEditor(this.props.process);
        if (coordinateSystemName && coordinateSystemDimensions.indexOf(newDimensionName) === -1) {
            editor.addDimension(coordinateSystemName, newDimensionName);
        }

        editor.renameVariableDimension(this.retrievedVariable.name, oldDimensionName, newDimensionName);

        editor.commit();
    };

    renderDimensionsList = () => {
        const dimensionsFields = [];

        this.retrievedVariable.dims.forEach((dimension, index) => {
            if (dimension === 'time' && index === 0) {
                dimensionsFields.push(<span key={`${dimension}-${index}`} className={css`padding: 2px 0 0 4px`}>{dimension}</span>);
            } else {
                const dimensionValue = Constants.convertValueToSelectValue(dimension);
                dimensionsFields.push(
                    <RIEComboBox
                        key={`${dimension}-${index}`}
                        value={dimensionValue}
                        options={this.getDimensionOptions()}
                        multi={false}
                        change={this.onDimensionNameUpdated}
                        fieldPath={[]}
                        creatable
                        isDisabled={!this.props.hasWritePermissions}
                        processId={this.props.process.name}
                        processErrors={this.props.processErrors}
                        minWidth="250px"
                        onChangeData={{ oldName: dimension }}
                        checkUnique={{ label: 'dimension', list: this.retrievedVariable.dims }}
                    />
                );
            }
        });

        if (dimensionsFields.length === 0) {
            return (
                <span className={emptyStyles}>No dimensions</span>
            );
        }
        return dimensionsFields;
    };

    render() {
        return (
            <Flexbox className={this.props.className} flexDirection="row" alignItems="flex-start" flexGrow={1}>
                {this.props.displayLabel &&
                <InfoBoxLabel
                    label="Variable Dimensions"
                    width={this.props.labelWidth}
                    labelWrap
                    alignTop
                />
                }
                <Flexbox flexDirection={'column'} flexGrow={1}>
                    {this.renderDimensionsList()}
                </Flexbox>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/VariableDimensionsField.js